export default "__VITE_ASSET__DHvBwhPu__"